<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        
        <b-button block v-b-toggle.term-section-1
        class="text-left fw-500 d-flex align-items-center justify-content-between">
            <div>
                <span class="box-numbering">01</span>
                <span>Introduction {{ companyName }}</span>    
            </div>
            <span 
                class="toggle-icon" 
                :class="{ active: isOpen }"
            >
                <span class="plus">+</span>
                <span class="cross">×</span>
            </span> 
        </b-button>
        
      </b-card-header>
      <b-collapse
        id="term-section-1"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify" v-html="$t(`('we,''us,''our') provides card solutions to individuals and businesses. These Terms apply to all users of ${companyName} products and services, including cardholders and website visitors.`)">
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-1",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
